// extracted by mini-css-extract-plugin
export var discard = "_1o-4";
export var muiTooltipTooltip = "_1o-6";
export var notificationBar = "_1o-3";
export var notificationContainer = "_1o-2";
export var saveButtonHoverSlotWrapper = "_1o-5";
export var show = "_1o-1";
export var spacer = "_1o-0";